import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import YardiLogo from './YardiLogo.vue'

export const yardiIntegration: PreviewIntegration = {
  id: 'yardi',
  name: 'Yardi',
  description:
    'Connect your real estate and property management data from Yardi to inform your AI.',
  icon: YardiLogo,
}
